(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4956],{

/***/ 90884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ ProductLoop; },
  "P": function() { return /* binding */ ProductLoopLoading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./libs/app/index.ts
var app = __webpack_require__(92517);
// EXTERNAL MODULE: ./components/index.ts + 88 modules
var components = __webpack_require__(85827);
// EXTERNAL MODULE: ./components/ui/NewGallery/index.tsx
var NewGallery = __webpack_require__(23303);
;// CONCATENATED MODULE: ./components/ui/SkeletonLoading/index.tsx


var SkeletonLoading = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(className, " skeleton")
    });
};
/* harmony default export */ var ui_SkeletonLoading = (SkeletonLoading);

;// CONCATENATED MODULE: ./components/loop/ProductLoop.tsx







var ProductLoop = function(props) {
    var ref, ref1, ref2;
    var p = props.p, t = props.t, catCode = props.catCode, isShowOriginPrice = props.isShowOriginPrice;
    var handle = "".concat((0,app/* createHandle */.UR)(p.product_name), "-").concat(p.id, "-").concat(p.product_code);
    var isDiscount = p.product_discount ? (0,app/* checkTime */.s)((ref = p.product_discount) === null || ref === void 0 ? void 0 : ref.started_at, (ref1 = p.product_discount) === null || ref1 === void 0 ? void 0 : ref1.ended_at) : false;
    if (p.product_discount && ((ref2 = p.product_discount) === null || ref2 === void 0 ? void 0 : ref2.status) === shared/* DiscountStatus.Ended */.YT.Ended) isDiscount = false;
    var isDeposited = p.quantity <= 0 || p.status == shared/* ProductStatus.CloseASale */.Pt.CloseASale || p.status === shared/* ProductStatus.Deposited */.Pt.Deposited;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full tw-h-full tw-bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-rounded-5 tw-border tw-border-gray-70 tw-overflow-hidden tw-w-full tw-h-full hover:tw-border-primary-main tw-duration-500 tw-ease-linear",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-w-full p-100p tw-relative tw-leading-0 tw-h-0 tw-bg-secondary-20",
                    children: [
                        p.images && p.images.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewGallery/* default */.Z, {
                                images: p.images
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                            alt: p.product_name,
                            src: p.images && p.images[0] ? p.images[0].url : "/bg-default.png"
                        }),
                        p.product_discount && isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-7 tw-h-7 tw-absolute tw-top-3 tw-right-3 tw-z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: "/sale.png",
                                    className: "tw-w-full tw-h-full",
                                    alt: "sale"
                                })
                            })
                        }),
                        p.is_auction && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-7 tw-h-7 tw-absolute tw-top-3 tw-right-3 tw-z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: "/auction.png",
                                    className: "tw-w-full tw-h-full",
                                    alt: "auction"
                                })
                            })
                        }),
                        isDeposited && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-absolute tw-z-10",
                            style: {
                                top: "8px",
                                left: "0"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PentagonIcon */.nM, {
                                    text: "Đ\xe3 b\xe1n"
                                }),
                                " "
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-pt-4 tw-pb-5",
                    children: [
                        catCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                            url: {
                                pathname: shared/* PagePath.CategoryProductPage */._.CategoryProductPage,
                                query: {
                                    id: catCode,
                                    slug: handle
                                }
                            },
                            className: "tw-h-12 md:tw-h-12 tw-px-1 tw-text-base tw-font-semibold tw-text-primary-main tw-w-full tw-line-clamp-2 tw-text-center",
                            children: p.product_name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                            url: {
                                pathname: shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                                query: {
                                    id: handle
                                }
                            },
                            className: "tw-h-12 md:tw-h-12 tw-px-1 tw-text-base tw-font-semibold tw-text-primary-main tw-w-full tw-line-clamp-2 tw-text-center",
                            children: p.product_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-secondary-81 tw-font-light tw-text-sm md:tw-text-base tw-line-clamp-1 tw-px-1",
                                    children: p.product_code
                                }),
                                p.quotation ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-secondary-70",
                                    children: "Li\xean hệ"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: p.is_auction && p.auction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                            children: (0,app/* toMoney */.KP)(p.auction.status === shared/* AuctionStatus.Pending */.wo.Pending ? p.auction.origin_price || 0 : p.auction.sell_price || 0, t, shared/* PriceSymbol.$ */.hb.$)
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: p.product_discount && isDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                isShowOriginPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-block tw-mt-1 tw-text-secondary-81 tw-font-light tw-text-sm tw-line-through tw-italic",
                                                    children: (0,app/* toMoney */.KP)(p.price, t, shared/* PriceSymbol.$ */.hb.$)
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                                    children: (0,app/* toMoney */.KP)(p.price - p.price * p.product_discount.discount / 100, t, shared/* PriceSymbol.$ */.hb.$)
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                                children: (0,app/* toMoney */.KP)(p.price, t, shared/* PriceSymbol.$ */.hb.$)
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var ProductLoopLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full tw-h-full tw-bg-white tw-border tw-border-gray-70",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-rounded-5 tw-overflow-hidden tw-w-full tw-h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-w-full p-100p tw-relative tw-h-0 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                        className: "tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-pt-4 tw-pb-5 tw-px-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                            className: "tw-h-12 md:tw-h-12 tw-rounded"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-center tw-mt-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                                    className: "tw-h-6 tw-rounded"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                                    className: "tw-h-6 tw-mt-1 tw-rounded"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 34794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85827);
/* harmony import */ var _contexts_profile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48309);




var TitlePartial = function(param) {
    var name = param.name, className = param.className, cs = param.cs;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_3__/* .useMasterData */ .AE)();
    var theme = (masterData !== null && masterData !== void 0 ? masterData : {}).theme;
    var icon_category_url = (theme !== null && theme !== void 0 ? theme : {}).icon_category_url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "_title tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-justify-center  tw-w-full  tw-relative ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-w-max tw-px-5 tw-justify-center ",
            children: [
                icon_category_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: icon_category_url,
                    alt: "star",
                    className: "tw-h-8 tw-w-8"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: "/diamond.svg",
                    alt: "star",
                    className: "tw-h-5 tw-w-5"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold ".concat(cs),
                    children: name
                }),
                icon_category_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: icon_category_url,
                    alt: "star",
                    className: "tw-h-8 tw-w-8"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: "/diamond.svg",
                    alt: "star",
                    className: "tw-h-5 tw-w-5"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(TitlePartial));


/***/ }),

/***/ 17852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mM": function() { return /* binding */ useRemindResellQuery; },
/* harmony export */   "uJ": function() { return /* binding */ useCreateChatConversation; },
/* harmony export */   "uK": function() { return /* binding */ useFetchConversationByProductQuery; }
/* harmony export */ });
/* unused harmony exports fetchProduct, fetchProductAuth, fetchConversationByProduct, createConversation, fetchAccountProfile, useFetchUserQuery, RemindResell */
/* harmony import */ var _libs_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80787);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7806);



var fetchProduct = function(id) {
    return axios.get("/api/v1/products/".concat(id));
};
var fetchProductAuth = function(id, token) {
    return axios.get("/api/v1/products/".concat(id), {
        headers: {
            Authorization: "Bearer ".concat(token)
        }
    });
};
var fetchConversationByProduct = function(id) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_0__/* .AxiosChatInstance.get */ .WA.get("/v2/me/chat/conversations/type/product/".concat(id));
};
var createConversation = function(payload) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_0__/* .AxiosChatInstance.post */ .WA.post("/v2/me/chat/conversations", payload);
};
var useCreateChatConversation = function(options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(function(payload) {
        return createConversation(payload);
    }, options);
};
var useFetchConversationByProductQuery = function(id, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.Conversations */ .S8.Conversations,
        id
    ], function() {
        return fetchConversationByProduct(id);
    }, options);
};
var fetchAccountProfile = function() {
    return axios.get("/api/v1/user/profile");
};
var useFetchUserQuery = function(options) {
    return useQuery([
        QueryKey.Users
    ], function() {
        return fetchAccountProfile();
    }, options);
};
var RemindResell = function(payload) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/api/v1/products/remind/resell", payload);
};
var useRemindResellQuery = function(options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(function(payload) {
        return RemindResell(payload);
    }, options);
};


/***/ }),

/***/ 44956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ detail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./libs/app/index.ts
var app = __webpack_require__(92517);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./components/index.ts + 88 modules
var components = __webpack_require__(85827);
;// CONCATENATED MODULE: ./features/products/detail/partials/info/countdown.tsx



var CountDown = function(param) {
    var startTime = param.startTime, endTime = param.endTime, showCountDown = param.showCountDown, t = param.t;
    var countDownDate = new Date(endTime).getTime();
    var ref = (0,react.useState)(true), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)("0"), day = ref1[0], setDay = ref1[1];
    var ref2 = (0,react.useState)("0"), hours = ref2[0], setHours = ref2[1];
    var ref3 = (0,react.useState)("0"), minute = ref3[0], setMinute = ref3[1];
    var ref4 = (0,react.useState)("0"), second = ref4[0], setSecond = ref4[1];
    (0,react.useEffect)(function() {
        var distance = 0;
        var interval = setInterval(function() {
            var now = (0,app/* parseUtcTime */.Ec)();
            distance = countDownDate - now;
            setDay((0,app/* pad */.vk)(Math.floor(distance / (1000 * 60 * 60 * 24))));
            setHours((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60))));
            setMinute((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60 * 60) / (1000 * 60))));
            setSecond((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60) / 1000)));
            if (Math.round(distance / 1000) === 1) {
                setShow(false);
                clearInterval(interval);
                showCountDown && showCountDown();
            // router.reload();
            }
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        endTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-text-white tw-flex tw-gap-x-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-border-primary-main tw-border tw-text-primary-main tw-font-semibold tw-flex tw-items-center tw-justify-center tw-text-26 tw-rounded-5 tw-mb-1 tw-w-[45px] tw-h-15",
                            children: day
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-13 tw-text-secondary-70",
                            children: t("detail.label.day")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-border-primary-main tw-border tw-text-primary-main tw-font-semibold tw-flex tw-items-center tw-justify-center tw-text-26 tw-rounded-5 tw-mb-1 tw-w-[45px] tw-h-15",
                            children: hours
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-13 tw-text-secondary-70",
                            children: t("detail.label.hour")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-border-primary-main tw-border tw-text-primary-main tw-font-semibold tw-flex tw-items-center tw-justify-center tw-text-26 tw-rounded-5 tw-mb-1 tw-w-[45px] tw-h-15",
                            children: minute
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-13 tw-text-secondary-70",
                            children: t("detail.label.minute")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-border-primary-main tw-border tw-text-primary-main tw-font-semibold tw-flex tw-items-center tw-justify-center tw-text-26 tw-rounded-5 tw-mb-1 tw-w-[45px] tw-h-15",
                            children: second
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-13 tw-text-secondary-70",
                            children: t("detail.label.second")
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./contexts/profile/index.tsx
var contexts_profile = __webpack_require__(48309);
// EXTERNAL MODULE: ./components/icons/DollarCircle/index.tsx
var DollarCircle = __webpack_require__(61058);
;// CONCATENATED MODULE: ./features/products/detail/partials/info/index.tsx









var InfoPartial = function(param) {
    var data = param.data, isAuth = param.isAuth, t = param.t, onConsultClick = param.onConsultClick, isDeposited = param.isDeposited, onDepositClick = param.onDepositClick, isConsultLoading = param.isConsultLoading, onRemindClick = param.onRemindClick, auction = param.auction;
    var router = (0,next_router.useRouter)();
    var masterData = (0,contexts_profile/* useMasterData */.AE)();
    var ambassadorInfo = masterData === null || masterData === void 0 ? void 0 : masterData.ambassador_info;
    var profile = (0,contexts_profile/* useProfile */.Un)();
    var ref = data !== null && data !== void 0 ? data : {}, price = ref.price, token = ref.token, isAuction = ref.is_auction, isPartner = ref.is_partner, productId = ref.id, productCode = ref.product_code, productNameDetail = ref.product_name_detail, tags = ref.tags, status = ref.status, product_discount = ref.product_discount, quotation = ref.quotation, description = ref.description, branch = ref.branch;
    console.log("data: ", data);
    var ref1;
    var ref2 = (ref1 = data === null || data === void 0 ? void 0 : data.attributes) !== null && ref1 !== void 0 ? ref1 : {}, color = ref2.color, gemSize = ref2.gem_size, gemType = ref2.gem_type, gemPure = ref2.gem_pure, gemSmall = ref2.gem_small, gemWeight = ref2.gem_weight, gemMaterial = ref2.gem_material, jewelryMaterial = ref2.jewelry_material, niNumber = ref2.ni_number, gemMasterSize = ref2.gem_master_size, inspectionCertificate = ref2.inspection_certificate;
    var items = [
        {
            label: t("detail.label.gem-material"),
            value: gemMaterial
        },
        {
            label: t("detail.label.gem-master-size"),
            value: gemMasterSize
        },
        {
            label: t("detail.label.gem-type"),
            value: gemType
        },
        {
            label: t("detail.label.color"),
            value: color
        },
        {
            label: t("detail.label.gem-pure"),
            value: gemPure
        },
        {
            label: t("detail.label.gem-small"),
            value: gemSmall
        },
        {
            label: t("detail.label.jewelry-t-material"),
            value: jewelryMaterial
        },
        {
            label: t("detail.label.ni-number"),
            value: niNumber
        },
        {
            label: t("detail.label.gem-size"),
            value: gemSize
        },
        {
            label: t("detail.label.gem-weight"),
            value: gemWeight
        },
        {
            label: t("detail.label.inspection-certificate"),
            value: inspectionCertificate
        }, 
    ];
    var isTimeDiscount = false;
    if (product_discount) {
        isTimeDiscount = new Date(new Date().toISOString()).getTime() - new Date(new Date(product_discount === null || product_discount === void 0 ? void 0 : product_discount.ended_at).toISOString()).getTime() < 0;
    }
    var ref3 = (0,react.useState)(true), show = ref3[0], setShow = ref3[1];
    var ref4 = (0,react.useState)(data.reminding_resell_product ? true : false), checked = ref4[0], setChecked = ref4[1];
    var showCountDown = function() {
        setShow(false);
    };
    var remindProduct = function() {
        setChecked(!checked);
        onRemindClick(!checked);
    };
    var isDiscount = product_discount ? (0,app/* checkTime */.s)(product_discount === null || product_discount === void 0 ? void 0 : product_discount.started_at, product_discount === null || product_discount === void 0 ? void 0 : product_discount.ended_at) : false;
    if (product_discount && (product_discount === null || product_discount === void 0 ? void 0 : product_discount.status) === shared/* DiscountStatus.Ended */.YT.Ended) isDiscount = false;
    var getProductCommission = function() {
        if (!(profile === null || profile === void 0 ? void 0 : profile.is_ambassador)) {
            return null;
        }
        var userLevel = profile === null || profile === void 0 ? void 0 : profile.level;
        var productConfigs = data === null || data === void 0 ? void 0 : data.ambassador_commission_configs;
        if (!userLevel || !productConfigs) {
            return null;
        }
        return productConfigs.find(function(item) {
            return item.user_level === userLevel;
        });
    };
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-y-4 tw-overflow-hidden",
        children: [
            show && isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-py-3 tw-px-4 tw-flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown, {
                            startTime: product_discount.started_at,
                            endTime: product_discount.ended_at,
                            showCountDown: showCountDown,
                            t: t
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-ml-4 tw-mt-5 tw-text-secondary-70 tw-text-base tw-lowercase",
                            children: t("detail.label.time-discount")
                        })
                    ]
                })
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-w-full md:tw-px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                dangerouslySetInnerHTML: {
                                    __html: productNameDetail
                                },
                                className: "tw-text-22 tw-line-clamp-2 tw-text-primary-main"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                dangerouslySetInnerHTML: {
                                    __html: productNameDetail
                                },
                                className: "tw-hidden"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                dangerouslySetInnerHTML: {
                                    __html: productNameDetail
                                },
                                className: "tw-hidden"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "tw-mt-1 tw-text-secondary-70 tw-flex tw-items-center tw-gap-1",
                                children: [
                                    productCode,
                                    isPartner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-w-[1px] tw-h-4 tw-bg-secondary-70"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: (0,app/* getCity */.hw)(branch)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            tags && !!tags.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-mt-1 tw-text-secondary-70",
                                children: [
                                    "tags:",
                                    " ",
                                    tags.map(function(tag, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                                    url: {
                                                        pathname: shared/* PagePath.ProductsPage */._.ProductsPage,
                                                        query: {
                                                            tag: tag.tag_name
                                                        }
                                                    },
                                                    className: "!tw-text-blue-50",
                                                    children: [
                                                        "#",
                                                        tag.tag_name
                                                    ]
                                                }),
                                                index < tags.length - 1 ? ", " : ""
                                            ]
                                        }, "tag-".concat(index));
                                    })
                                ]
                            })
                        ]
                    }),
                    isAuction && auction && auction.status != shared/* AuctionStatus.Ended */.wo.Ended ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-lg",
                                    children: "Gi\xe1 khởi điểm:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-space-x-3 tw-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-font-bold tw-text-warning-90",
                                            children: (0,app/* toMoney */.KP)(auction.origin_price || 0, t)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-font-bold",
                                            children: "~"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-font-bold tw-text-primary-main",
                                            children: (0,app/* toMoney */.KP)((auction.origin_price || 0) / 100000, t, shared/* PriceSymbol.Atd */.hb.Atd)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-lg tw-mt-3",
                                    children: "Gi\xe1 hiện tại:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-space-x-3 tw-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-font-bold tw-text-warning-90",
                                            children: (0,app/* toMoney */.KP)(auction.sell_price || 0, t)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-font-bold",
                                            children: "~"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-font-bold tw-text-primary-main",
                                            children: (0,app/* toMoney */.KP)((auction.sell_price || 0) / 100000, t, shared/* PriceSymbol.Atd */.hb.Atd)
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !quotation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-pt-4 tw-pb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-flex tw-gap-x-2 tw-leading-8 tw-text-26",
                                    children: show && isDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold tw-text-warning-90",
                                                children: (0,app/* toMoney */.KP)(price - price * product_discount.discount / 100, t)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold",
                                                children: "~"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold tw-text-primary-main",
                                                children: (0,app/* toMoney */.KP)(token - token * product_discount.discount / 100, t, shared/* PriceSymbol.Atd */.hb.Atd)
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold tw-text-warning-90",
                                                children: (0,app/* toMoney */.KP)(price, t)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold",
                                                children: "~"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold tw-text-primary-main",
                                                children: (0,app/* toMoney */.KP)(token, t, shared/* PriceSymbol.Atd */.hb.Atd)
                                            })
                                        ]
                                    })
                                }),
                                isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-mt-1 tw-text-gray-60",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-line-through tw-text-lg",
                                        children: [
                                            (0,app/* toMoney */.KP)(price, t),
                                            " ~ ",
                                            (0,app/* toMoney */.KP)(token, t, shared/* PriceSymbol.Atd */.hb.Atd)
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-flex-col tw-items-center sm:tw-flex-row tw-gap-y-4 tw-gap-x-0 sm:tw-gap-x-4 sm:tw-gap-y-0 tw-pb-8 !tw-w-full",
                        children: quotation ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-full tw-flex tw-justify-start tw-mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                disabled: status !== shared/* ProductStatus.Availability */.Pt.Availability,
                                onClick: onConsultClick,
                                loading: isConsultLoading,
                                className: "tw-flex tw-items-center tw-justify-center !tw-w-44 !tw-rounded-5 sm:tw-w-1/2 tw-text-warning-90 tw-border-warning-90",
                                variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-flex tw-text-lg tw-gap-x-4 tw-justify-center tw-uppercase",
                                    children: t("detail.btn.contact")
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                    disabled: !isAuth || isDeposited,
                                    onClick: onConsultClick,
                                    loading: isConsultLoading,
                                    className: "tw-flex tw-items-center tw-justify-center !tw-w-48 !tw-rounded-5 sm:tw-w-1/2",
                                    variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-text-lg tw-justify-center tw-uppercase",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                className: "tw-mr-4",
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MessageLightIcon */.Mt, {})
                                            }),
                                            t("detail.btn.consult")
                                        ]
                                    })
                                }),
                                !isPartner && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                    disabled: !isAuth || isDeposited || isAuction || isPartner,
                                    onClick: onDepositClick,
                                    className: "w-flex tw-items-center tw-justify-center !tw-w-48 !tw-rounded-5 sm:tw-w-1/2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-gap-x-4 tw-justify-center tw-text-lg tw-uppercase",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WalletIcon */.o, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: isDeposited ? t("detail.btn.soldOut") : t("detail.btn.deposit")
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    isAuth ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: status != shared/* ProductStatus.Availability */.Pt.Availability && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-border-b tw-items-center tw-border-primary-main tw-border-opacity-50 tw-pb-6 tw-gap-x-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-lg tw-flex-1 tw-italic",
                                    children: "Nhận th\xf4ng b\xe1o khi sản phẩm được mở b\xe1n lại"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "tw-mr-2 tw-mt-[0.3rem] tw-h-6 tw-w-10 tw-appearance-none tw-rounded-[3rem] tw-bg-[#D9D9D9] before:tw-pointer-events-none before:tw-absolute before:tw-h-3.5 before:tw-w-3.5 before:tw-rounded-full before:tw-bg-transparent before:tw=-content-[''] after:tw-absolute after:tw-z-[2] after:tw-mt-[0.125rem] after:tw-ml-[0.15rem] after:tw-h-5 after:tw-w-5 after:tw-rounded-full after:tw-border-none after:tw-bg-[#D9D9D9] after:tw-shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:tw-transition-[background-color_0.2s,transform_0.2s] after:tw-content-[''] checked:tw-bg-primary-main checked:after:tw-absolute checked:after:tw-z-[2] checked:after:tw-mt-[0.125rem] checked:after:tw-ml-[1.0625rem] checked:after:tw-h-5 checked:after:tw-w-5 checked:after:tw-rounded-full checked:after:tw-border-none checked:after:tw-bg-primary checked:after:tw-shadow-[0_4px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:tw-transition-[background-color_0.2s,transform_0.2s] checked:after:tw-content-[''] hover:tw-cursor-pointer focus:tw-outline-none focus:tw-ring-0 focus:before:tw-scale-100 focus:before:tw-opacity-0 focus:before:tw-shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:tw-transition-[box-shadow_0.2s,transform_0.2s] focus:after:tw-absolute focus:after:tw-z-[1] focus:after:tw-block focus:after:tw-h-5 focus:after:tw-w-5 focus:after:tw-rounded-full focus:after:tw-content-[''] checked:focus:tw-border-primary-main checked:focus:tw-bg-primary-main checked:focus:before:tw-ml-[1.0625rem] checked:focus:before:tw-scale-100 checked:focus:before:tw-shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:tw-transition-[box-shadow_0.2s,transform_0.2s] dark:tw-bg-[#D9D9D9] dark:after:tw-bg-white dark:checked:tw-bg-primary dark:checked:after:tw-bg-primary dark:focus:before:tw-shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:tw-shadow-[3px_-1px_0px_13px_#3b71ca]",
                                    type: "checkbox",
                                    role: "switch",
                                    id: "flexSwitchCheckDefault01",
                                    checked: checked,
                                    onChange: function() {
                                        return remindProduct();
                                    }
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    data.ambassador_commission_configs && data.ambassador_commission_configs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: isAuth && (profile === null || profile === void 0 ? void 0 : profile.is_ambassador) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: getProductCommission() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-pb-6 tw-text-primary-main tw-text-right tw-italic tw-border-b tw-border-primary-main",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-items-center tw-justify-end",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DollarCircle/* DollarCircleIcon */.A, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "tw-ml-1",
                                            children: [
                                                t("detail.label.auth-commission-label"),
                                                ": ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: (0,app/* toMoney */.KP)(getProductCommission().commission_price, t)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-pb-6 tw-text-primary-main tw-text-right tw-italic tw-border-b tw-border-primary-main",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-items-center tw-justify-end",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DollarCircle/* DollarCircleIcon */.A, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-ml-1",
                                            children: ambassadorInfo === null || ambassadorInfo === void 0 ? void 0 : ambassadorInfo.title_commission
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-underline",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        url: {
                                            pathname: "/article/".concat((0,app/* getSlugFromUrl */.KX)((ref5 = ambassadorInfo === null || ambassadorInfo === void 0 ? void 0 : ambassadorInfo.url) !== null && ref5 !== void 0 ? ref5 : ""))
                                        },
                                        target: "_blank",
                                        children: t("detail.label.become-ambassador")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-border-t tw-border-primary-70"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-gap-y-1 tw-flex-col tw-mt-6",
                        children: [
                            isPartner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "tw-flex tw-items-center tw-text-primary-main",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DiamondFilledIcon */.hD, {}),
                                                className: "tw-w-5 tw-h-5 tw-opacity-50 tw-mr-2"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-xl",
                                                children: t("detail.detail")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-mt-3 tw-whitespace-pre-wrap tw-leading-8",
                                        children: description
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "tw-flex tw-items-center tw-text-primary-main",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DiamondFilledIcon */.hD, {}),
                                                className: "tw-w-5 tw-h-5 tw-opacity-50 tw-mr-2"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-xl",
                                                children: t("detail.description")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-mt-3",
                                        children: items.map(function(param, index) {
                                            var value = param.value, label = param.label;
                                            if (value) {
                                                return value && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "tw-flex tw-pl-2 tw-items-start tw-text-lg",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-flex tw-items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tw-w-1 tw-h-1 tw-rounded-full tw-bg-black tw-mr-4"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tw-text-lg tw-text-secondary-70",
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: label
                                                                    }
                                                                }),
                                                                ":"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "tw-flex-1 tw-font-bold tw-ml-3",
                                                            dangerouslySetInnerHTML: {
                                                                __html: value
                                                            }
                                                        })
                                                    ]
                                                }, "item-index-".concat(index));
                                            }
                                        })
                                    })
                                ]
                            }),
                            !isPartner && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-mt-3 tw-flex tw-flex-col tw-text-base tw-gap-2",
                                children: [
                                    isAuth ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        url: "/guide-to-measuring-hands/",
                                        className: "!tw-text-blue-50 tw-italic",
                                        target: "_blank",
                                        children: "Hướng dẫn đo k\xedch thước v\xe0 quy đổi size"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        url: "/guide-to-measuring-hands/",
                                        className: "!tw-text-blue-50 tw-italic",
                                        target: "_blank",
                                        children: "Hướng dẫn đo k\xedch thước v\xe0 quy đổi size"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        url: {
                                            pathname: shared/* PagePath.ProductWarrantyPolicyPage */._.ProductWarrantyPolicyPage
                                        },
                                        className: "!tw-text-blue-50 tw-italic",
                                        target: "_blank",
                                        children: "Xem ch\xednh s\xe1ch bảo h\xe0nh sản phẩm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        url: {
                                            pathname: shared/* PagePath.RefundPolicyPage */._.RefundPolicyPage
                                        },
                                        className: "!tw-text-blue-50 tw-italic",
                                        target: "_blank",
                                        children: "Xem ch\xednh s\xe1ch thu đổi"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        url: {
                                            pathname: shared/* PagePath.ConsignPolicyPage */._.ConsignPolicyPage
                                        },
                                        className: "!tw-text-blue-50 tw-italic",
                                        target: "_blank",
                                        children: "Xem ch\xednh s\xe1ch mua b\xe1n/k\xfd gửi sản phẩm"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var info = (InfoPartial);

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(30706);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
;// CONCATENATED MODULE: ./features/products/detail/partials/gallery/index.tsx




// Import Swiper styles




// import required modules

var GalleryPartial = function(param) {
    var images = param.images, isMobile = param.isMobile, handleModal = param.handleModal, linkVideo = param.linkVideo, t = param.t;
    var handleMouseMove = function handleMouseMove(evt) {
        var e = evt || window.event;
        var rect = document.getElementById("swiper").getBoundingClientRect();
        if (!rect) return;
        var x = (e.clientX - (rect.x || 0)) / (rect.width - 2) * 100 || 50; // Wonderfully
        var y = (e.clientY - (rect.y || 0)) / (rect.height - 2) * 100 || 50; // Simple!
        // if (rect.top) {
        //   x = x - rect.left;
        //   y = y - rect.top;
        // }
        setPositions({
            x: x.toFixed(4),
            y: y.toFixed(4)
        });
    };
    var ref = (0,react.useState)(null), thumbsSwiper = ref[0], setThumbsSwiper = ref[1];
    var ref1 = (0,react.useState)({
        x: "center",
        y: "center"
    }), positions = ref1[0], setPositions = ref1[1];
    var items = (Array.isArray(images) ? images : []).map(function(param) {
        var url = param.url;
        return {
            original: url,
            thumbnail: url,
            originalAlt: "Product image",
            thumbnailAlt: "product thumbnail image"
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    keyboard: {
                        enabled: true
                    },
                    pagination: {
                        clickable: true
                    },
                    thumbs: {
                        swiper: thumbsSwiper
                    },
                    modules: isMobile ? [
                        swiper_esm/* FreeMode */.Rv,
                        swiper_esm/* Keyboard */.N1,
                        swiper_esm/* Pagination */.tl
                    ] : [
                        swiper_esm/* FreeMode */.Rv,
                        swiper_esm/* Keyboard */.N1,
                        swiper_esm/* Thumbs */.o3
                    ],
                    className: "product-images",
                    id: "swiper",
                    children: [
                        items.map(function(item, key) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: "tw-bg-gray-50 md:tw-rounded-5 md:tw-border tw-border-gray-70 tw-border-opacity-50 tw-overflow-hidden tw-relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-w-full p-100p tw-relative",
                                    onMouseMove: handleMouseMove,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "!tw-absolute tw-bg-center tw-bg-cover tw-bg-no-repeat tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-1 hover:tw-transform tw-transition tw-ease-in-out tw-duration-300 hover:tw-scale-[2.25]",
                                        style: {
                                            backgroundImage: "url('".concat(item.original, "')"),
                                            transformOrigin: "".concat(positions === null || positions === void 0 ? void 0 : positions.x, "% ").concat(positions === null || positions === void 0 ? void 0 : positions.y, "%")
                                        }
                                    })
                                })
                            }, "item-".concat(key));
                        }),
                        linkVideo && (!isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-absolute tw-bottom-4 tw-left-1/2 tw--translate-x-1/2 tw-z-10 tw-py-2 tw-px-4 tw-flex tw-items-center tw-gap-x-2 tw-cursor-pointer tw-bg-primary-main tw-text-white tw-rounded-5",
                            onClick: handleModal,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VideoIcon */.Od, {})
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("detail.label.watch-video")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-absolute tw-block md:tw-hidden tw-top-6 tw-right-4 tw-z-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex tw-items-center tw-justify-center tw-flex-col tw-w-10 tw-h-10 tw-cursor-pointer tw-bg-white tw-text-primary-main tw-rounded-full",
                                onClick: function() {
                                    return handleModal();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VideoIcon */.Od, {})
                                })
                            })
                        }))
                    ]
                }),
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    spaceBetween: 20,
                    slidesPerView: 4,
                    freeMode: true,
                    watchSlidesProgress: true,
                    onSwiper: setThumbsSwiper,
                    modules: [
                        swiper_esm/* FreeMode */.Rv,
                        swiper_esm/* Thumbs */.o3
                    ],
                    className: "product-images-thumb tw-mt-5 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: items.map(function(item, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: "tw-bg-gray-50 tw-rounded-5 tw-border tw-border-gray-70 tw-overflow-hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-w-full p-100p tw-relative tw-bg-gray-50 tw-rounded-5 ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: item.original,
                                        className: "!tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full",
                                        alt: item.originalAlt
                                    })
                                })
                            }, "item-".concat(key));
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var gallery = (/*#__PURE__*/(0,react.memo)(GalleryPartial));

;// CONCATENATED MODULE: ./features/products/detail/partials/breadcrumb/index.tsx




var BreadCrumbPartial = function(param) {
    var title = param.title, categoryName = param.categoryName, categoryCode = param.categoryCode, _isPartner = param.isPartner, isPartner = _isPartner === void 0 ? false : _isPartner, partnerId = param.partnerId, partnerName = param.partnerName, t = param.t;
    if (isPartner) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-hidden md:tw-flex tw-gap-x-2 tw-items-center !tw-text-secondary-70 tw-text-lg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                        className: "!tw-text-secondary-70 tw-max-w hover:tw-underline hover:!tw-text-primary-main",
                        url: {
                            pathname: shared/* PagePath.HomePage */._.HomePage,
                            hash: "doi-tac-an-thu"
                        },
                        children: t("detail.partner")
                    }),
                    "\xa0",
                    partnerId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            " > ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                className: "!tw-text-secondary-70 hover:tw-underline hover:!tw-text-primary-main",
                                url: {
                                    pathname: shared/* PagePath.PartnerDetail */._.PartnerDetail,
                                    query: {
                                        id: partnerId
                                    }
                                },
                                children: partnerName
                            })
                        ]
                    }),
                    "\xa0",
                    " > ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "!tw-text-secondary-70 tw-line-clamp-1 tw-flex-1",
                        children: title
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-hidden md:tw-flex tw-gap-x-2 tw-items-center !tw-text-secondary-70 tw-text-lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                    className: "!tw-text-secondary-70 tw-max-w hover:tw-underline hover:!tw-text-primary-main",
                    url: {
                        pathname: shared/* PagePath.ProductsPage */._.ProductsPage
                    },
                    children: t("detail.product")
                }),
                "\xa0",
                categoryCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        " > ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                            className: "!tw-text-secondary-70 hover:tw-underline hover:!tw-text-primary-main",
                            url: {
                                pathname: shared/* PagePath.CategoryPage */._.CategoryPage,
                                query: {
                                    id: categoryCode.toLocaleLowerCase()
                                }
                            },
                            children: categoryName
                        })
                    ]
                }),
                "\xa0",
                " > ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "!tw-text-secondary-70 tw-line-clamp-1 tw-flex-1",
                    children: title
                })
            ]
        })
    });
};
/* harmony default export */ var breadcrumb = (/*#__PURE__*/(0,react.memo)(BreadCrumbPartial));

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95298);
// EXTERNAL MODULE: ./features/products/list/api.ts
var api = __webpack_require__(81525);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
// EXTERNAL MODULE: ./features/products/detail/partials/RelatedProduct/index.tsx
var RelatedProduct = __webpack_require__(52685);
// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
;// CONCATENATED MODULE: ./features/products/detail/partials/InfoMobile/index.tsx






var InfoMobilePartial = function(param) {
    var data = param.data, isAuth = param.isAuth, t = param.t, onRemindClick = param.onRemindClick;
    var ref = data !== null && data !== void 0 ? data : {}, isAuction = ref.is_auction, isPartner = ref.is_partner, price = ref.price, token = ref.token, productCode = ref.product_code, productNameDetail = ref.product_name_detail, cateName = ref.cat_name, liveStreamProducts = ref.live_stream_product, tags = ref.tags, product_discount = ref.product_discount, quotation = ref.quotation, status = ref.status, auction = ref.auction, branch = ref.branch;
    var ref1;
    var ref2 = (ref1 = data === null || data === void 0 ? void 0 : data.attributes) !== null && ref1 !== void 0 ? ref1 : {}, color = ref2.color, gemSize = ref2.gem_size, gemType = ref2.gem_type, gemPure = ref2.gem_pure, gemSmall = ref2.gem_small, gemWeight = ref2.gem_weight, gemMaterial = ref2.gem_material, jewelryMaterial = ref2.jewelry_material, niNumber = ref2.ni_number, gemMasterSize = ref2.gem_master_size;
    var items = [
        {
            label: t("detail.label.gem-material"),
            value: gemMaterial
        },
        {
            label: t("detail.label.gem-master-size"),
            value: gemMasterSize
        },
        {
            label: t("detail.label.gem-type"),
            value: gemType
        },
        {
            label: t("detail.label.color"),
            value: color
        },
        {
            label: t("detail.label.gem-pure"),
            value: gemPure
        },
        {
            label: t("detail.label.gem-small"),
            value: gemSmall
        },
        {
            label: t("detail.label.jewelry-t-material"),
            value: jewelryMaterial
        },
        {
            label: t("detail.label.ni-number"),
            value: niNumber
        },
        {
            label: t("detail.label.gem-size"),
            value: gemSize
        },
        {
            label: t("detail.label.gem-weight"),
            value: gemWeight
        }, 
    ];
    var ref3 = (0,react.useState)(data.reminding_resell_product ? true : false), checked = ref3[0], setChecked = ref3[1];
    var isTimeDiscount = false;
    if (product_discount) {
        isTimeDiscount = new Date(new Date().toISOString()).getTime() - new Date(new Date(product_discount === null || product_discount === void 0 ? void 0 : product_discount.ended_at).toISOString()).getTime() < 0;
    }
    var ref4 = (0,react.useState)(true), show = ref4[0], setShow = ref4[1];
    var showCountDown = function() {
        setShow(false);
    };
    var remindProduct = function() {
        setChecked(!checked);
        onRemindClick(!checked);
    };
    var isDiscount = product_discount ? (0,app/* checkTime */.s)(product_discount === null || product_discount === void 0 ? void 0 : product_discount.started_at, product_discount === null || product_discount === void 0 ? void 0 : product_discount.ended_at) : false;
    if (product_discount && (product_discount === null || product_discount === void 0 ? void 0 : product_discount.status) === shared/* DiscountStatus.Ended */.YT.Ended) isDiscount = false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-pt-5 tw-gap-y-4 tw-overflow-hidden",
        children: [
            show && isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-px-4 tw-flex tw-flex-col tw-items-center tw-gap-y-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " tw-text-secondary-70 tw-text-base",
                            children: t("detail.label.time-discount")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown, {
                            startTime: product_discount.started_at,
                            endTime: product_discount.ended_at,
                            showCountDown: showCountDown,
                            t: t
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-w-full tw-px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                dangerouslySetInnerHTML: {
                                    __html: productNameDetail
                                },
                                className: "tw-leading-6 tw-text-lg tw-line-clamp-2 tw-text-black tw-font-semibold"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                dangerouslySetInnerHTML: {
                                    __html: productNameDetail
                                },
                                className: "tw-hidden"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "tw-mt-1 tw-text-secondary-70",
                                children: [
                                    t("detail.label.code", {
                                        value: productCode
                                    }),
                                    " |",
                                    " ",
                                    t("detail.label.cate", {
                                        value: cateName
                                    }),
                                    " ",
                                    isPartner && " | ".concat((0,app/* getCity */.hw)(branch))
                                ]
                            }),
                            tags && !!tags.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-mt-1 tw-text-secondary-70",
                                children: [
                                    "tags:",
                                    " ",
                                    tags.map(function(tag, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                                    url: {
                                                        pathname: shared/* PagePath.ProductsPage */._.ProductsPage,
                                                        query: {
                                                            tag: tag.tag_name
                                                        }
                                                    },
                                                    className: "!tw-text-blue-50",
                                                    children: [
                                                        "#",
                                                        tag.tag_name
                                                    ]
                                                }),
                                                index < tags.length - 1 ? ", " : ""
                                            ]
                                        }, "tag-".concat(index));
                                    })
                                ]
                            })
                        ]
                    }),
                    isAuction && auction && auction.status != shared/* AuctionStatus.Ended */.wo.Ended ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-text-[#979797] tw-flex tw-items-center tw-mb-3 tw-line-through",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Gi\xe1 khởi điểm:\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-justify-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: (0,app/* toMoney */.KP)(auction.origin_price, t)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "\xa0~\xa0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: (0,app/* toMoney */.KP)(auction.origin_price / 100000, t, shared/* PriceSymbol.Atd */.hb.Atd)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-gap-x-2 tw-mt-1 tw-leading-8 tw-text-26 tw-border tw-border-dashed tw-border-gray-400 tw-py-4 tw-w-full tw-rounded-full !tw-text-lg md:!tw-text-xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-text-center",
                                        children: "Gi\xe1 hiện tại"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-justify-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold tw-text-warning-90",
                                                children: (0,app/* toMoney */.KP)(auction.sell_price || 0, t)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold",
                                                children: "\xa0~\xa0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold tw-text-primary-main",
                                                children: (0,app/* toMoney */.KP)((auction.sell_price || 0) / 100000, t, shared/* PriceSymbol.Atd */.hb.Atd)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !quotation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-pt-4 tw-pb-2",
                            children: [
                                isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-mt-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-line-through tw-text-base tw-text-gray-60",
                                        children: [
                                            t("detail.label.start-price"),
                                            ": ",
                                            (0,app/* toMoney */.KP)(price, t),
                                            " ~",
                                            " ",
                                            (0,app/* toMoney */.KP)(token, t, shared/* PriceSymbol.Atd */.hb.Atd)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-gap-x-2 tw-mt-1 tw-leading-8 tw-text-26 tw-border tw-border-dashed tw-border-gray-400 tw-py-4 tw-w-full tw-flex tw-items-center tw-justify-center tw-rounded-full !tw-text-lg md:!tw-text-xl",
                                    children: show && isDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold tw-text-warning-90",
                                                children: (0,app/* toMoney */.KP)(price - price * product_discount.discount / 100, t)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold",
                                                children: "~"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold tw-text-primary-main",
                                                children: (0,app/* toMoney */.KP)(token - token * product_discount.discount / 100, t, shared/* PriceSymbol.Atd */.hb.Atd)
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold tw-text-warning-90",
                                                children: (0,app/* toMoney */.KP)(price, t)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold",
                                                children: "\xa0~\xa0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-bold tw-text-primary-main",
                                                children: (0,app/* toMoney */.KP)(token, t, shared/* PriceSymbol.Atd */.hb.Atd)
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    !isPartner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-justify-end tw-py-5 ".concat(isAuth && status != shared/* ProductStatus.Availability */.Pt.Availability ? "" : "tw-border-b tw-border-primary-main tw-border-opacity-50"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                            url: "/guide-to-measuring-hands/",
                            className: "!tw-text-secondary-70 tw-text-sm !tw-underline tw-leading-7 tw-italic",
                            children: "Hướng dẫn đo k\xedch thước v\xe0 quy đổi size"
                        })
                    }),
                    isAuth && status != shared/* ProductStatus.Availability */.Pt.Availability && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-border-b tw-items-center tw-border-primary-main tw-border-opacity-50 tw-pb-6 tw-gap-x-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-text-sm tw-flex-1 tw-italic",
                                children: "Nhận th\xf4ng b\xe1o khi sản phẩm được mở b\xe1n lại"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "tw-mr-2 tw-mt-[0.3rem] tw-h-6 tw-w-10 tw-appearance-none tw-rounded-[3rem] tw-bg-[#D9D9D9] before:tw-pointer-events-none before:tw-absolute before:tw-h-3.5 before:tw-w-3.5 before:tw-rounded-full before:tw-bg-transparent before:tw=-content-[''] after:tw-absolute after:tw-z-[2] after:tw-mt-[0.125rem] after:tw-ml-[0.15rem] after:tw-h-5 after:tw-w-5 after:tw-rounded-full after:tw-border-none after:tw-bg-[#D9D9D9] after:tw-shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:tw-transition-[background-color_0.2s,transform_0.2s] after:tw-content-[''] checked:tw-bg-primary-main checked:after:tw-absolute checked:after:tw-z-[2] checked:after:tw-mt-[0.125rem] checked:after:tw-ml-[1.0625rem] checked:after:tw-h-5 checked:after:tw-w-5 checked:after:tw-rounded-full checked:after:tw-border-none checked:after:tw-bg-primary checked:after:tw-shadow-[0_4px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:tw-transition-[background-color_0.2s,transform_0.2s] checked:after:tw-content-[''] hover:tw-cursor-pointer focus:tw-outline-none focus:tw-ring-0 focus:before:tw-scale-100 focus:before:tw-opacity-0 focus:before:tw-shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:tw-transition-[box-shadow_0.2s,transform_0.2s] focus:after:tw-absolute focus:after:tw-z-[1] focus:after:tw-block focus:after:tw-h-5 focus:after:tw-w-5 focus:after:tw-rounded-full focus:after:tw-content-[''] checked:focus:tw-border-primary-main checked:focus:tw-bg-primary-main checked:focus:before:tw-ml-[1.0625rem] checked:focus:before:tw-scale-100 checked:focus:before:tw-shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:tw-transition-[box-shadow_0.2s,transform_0.2s] dark:tw-bg-[#D9D9D9] dark:after:tw-bg-white dark:checked:tw-bg-primary dark:checked:after:tw-bg-primary dark:focus:before:tw-shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:tw-shadow-[3px_-1px_0px_13px_#3b71ca]",
                                type: "checkbox",
                                role: "switch",
                                id: "flexSwitchCheckDefault01",
                                checked: checked,
                                onChange: function() {
                                    return remindProduct();
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-gap-y-1 tw-flex-col tw-pb-6 tw-pt-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: items.map(function(param, index) {
                                    var value = param.value, label = param.label;
                                    if (value) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-flex tw-justify-between tw-items-center tw-text-lg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-font-light tw-text-base tw-text-secondary-70",
                                                    dangerouslySetInnerHTML: {
                                                        __html: label
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-font-normal tw-text-base tw-ml-3",
                                                    dangerouslySetInnerHTML: {
                                                        __html: value
                                                    }
                                                })
                                            ]
                                        }, "item-index-".concat(index));
                                    }
                                })
                            }),
                            !isPartner && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-mt-3 tw-flex tw-flex-col tw-text-base tw-gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        url: {
                                            pathname: shared/* PagePath.ProductWarrantyPolicyPage */._.ProductWarrantyPolicyPage
                                        },
                                        className: "!tw-text-blue-50 tw-italic",
                                        target: "_blank",
                                        children: "Xem ch\xednh s\xe1ch bảo h\xe0nh sản phẩm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        url: {
                                            pathname: shared/* PagePath.RefundPolicyPage */._.RefundPolicyPage
                                        },
                                        className: "!tw-text-blue-50 tw-italic",
                                        target: "_blank",
                                        children: "Xem ch\xednh s\xe1ch thu đổi"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        url: {
                                            pathname: shared/* PagePath.ConsignPolicyPage */._.ConsignPolicyPage
                                        },
                                        className: "!tw-text-blue-50 tw-italic",
                                        target: "_blank",
                                        children: "Xem ch\xednh s\xe1ch mua b\xe1n/k\xfd gửi sản phẩm"
                                    })
                                ]
                            }),
                            !!liveStreamProducts && !isPartner && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-mt-10 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-base tw-font-light",
                                            children: t("detail.label.view")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-mt-3 tw-grid tw-gap-4",
                                        children: liveStreamProducts.map(function(live) {
                                            var handle = "".concat((0,app/* createHandle */.UR)(live.live_stream.name), "-").concat(live.live_stream_id);
                                            return live.status && live.start_datetime && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                                url: {
                                                    pathname: shared/* PagePath.LiveVideoPage */._.LiveVideoPage,
                                                    query: {
                                                        id: handle,
                                                        start: live.played
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-bg-muted-main tw-py-3 tw-px-4 tw-rounded-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LiveProduct */.SK, {
                                                        data: live
                                                    })
                                                })
                                            }, "live-" + live.live_stream_id);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var InfoMobile = (/*#__PURE__*/(0,react.memo)(InfoMobilePartial));

// EXTERNAL MODULE: ./models/index.ts + 1 modules
var models = __webpack_require__(11444);
;// CONCATENATED MODULE: ./features/products/detail/const.ts



// EXTERNAL MODULE: ./features/products/detail/api.ts
var detail_api = __webpack_require__(17852);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
// EXTERNAL MODULE: ./libs/hook/index.tsx + 3 modules
var hook = __webpack_require__(14339);
// EXTERNAL MODULE: ./libs/dayjs/index.ts
var dayjs = __webpack_require__(74865);
// EXTERNAL MODULE: ./features/livestream/detail/api.ts
var livestream_detail_api = __webpack_require__(77910);
;// CONCATENATED MODULE: ./features/products/detail/layout.tsx























var ProductDetailLayout = function(param) {
    var product = param.product, isAuth = param.isAuth, isMobile = param.isMobile, handle = param.handle, catCode = param.catCode;
    var ref, ref1, ref2;
    var t = (0,esm/* useTranslation */.$G)([
        "product",
        "layout"
    ]).t;
    var masterData = (0,contexts_profile/* useMasterData */.AE)();
    var theme = (masterData !== null && masterData !== void 0 ? masterData : {}).theme;
    var icon_category_url = (theme !== null && theme !== void 0 ? theme : {}).icon_category_url;
    var liveStreamProducts = product.live_stream_product, productId = product.id, isAuction = product.is_auction, isPartner = product.is_partner, product_discount = product.product_discount, seo = product.seo;
    var isDiscount = product_discount ? (0,app/* checkTime */.s)(product_discount === null || product_discount === void 0 ? void 0 : product_discount.started_at, product_discount === null || product_discount === void 0 ? void 0 : product_discount.ended_at) : false;
    if (product_discount && (product_discount === null || product_discount === void 0 ? void 0 : product_discount.status) === shared/* DiscountStatus.Ended */.YT.Ended) isDiscount = false;
    var ref3 = (0,react.useState)(), listProduct = ref3[0], setListProduct = ref3[1];
    var ref4 = (0,react.useState)(false), showModal = ref4[0], setShowModal = ref4[1];
    var ref5 = (0,react.useState)(), auction = ref5[0], setAuction = ref5[1];
    var ref6 = (0,api/* useFetchRelatedProductsQuery */.e5)({
        cat_code: product.cat_code,
        product_id: product.id
    }, {
        enabled: false,
        retry: true,
        retryDelay: 20,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            var _data = data.filter(function(d) {
                return d.product_code !== product.product_code;
            });
            setListProduct(_data);
        }
    }), refetch = ref6.refetch, isLoading = ref6.isLoading;
    var ref7 = (0,detail_api/* useRemindResellQuery */.mM)({
        onSuccess: function(param) {
            var data = param.data;
            if (data.remind) {
                react_hot_toast_esm/* default.success */.ZP.success("Đ\xe3 chọn nhận th\xf4ng b\xe1o khi sản phẩm được mở b\xe1n lại");
            } else {
                react_hot_toast_esm/* default.success */.ZP.success("Đ\xe3 huỷ nhận th\xf4ng b\xe1o khi sản phẩm được mở b\xe1n lại");
            }
        },
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        }
    }), mutateRemindProduct = ref7.mutate;
    var ref8 = (0,livestream_detail_api/* useFetchAuctionByProductId */.eD)(productId, {
        enabled: false,
        refetchOnWindowFocus: false,
        retry: false,
        onError: function() {
            return console.log("Failed to fetch auction");
        },
        onSuccess: function(param) {
            var data = param.data;
            return setAuction(data);
        }
    }), fetchAuction = ref8.refetch;
    (0,react.useEffect)(function() {
        if (productId && isAuction) {
            fetchAuction();
        }
    }, [
        productId,
        isAuction,
        fetchAuction
    ]);
    (0,react.useEffect)(function() {
        if (product.cat_code) {
            refetch();
        }
    }, [
        product.cat_code,
        refetch,
        product.id
    ]);
    (0,hook/* useDisableBodyScroll */.L7)(showModal);
    var onDepositClick = function() {
        return router_default().push({
            pathname: shared/* PagePath.ProductDepositPage */._.ProductDepositPage,
            query: {
                id: product.id
            }
        });
    };
    var ref9 = (0,detail_api/* useCreateChatConversation */.uJ)({
        onSuccess: function(param) {
            var data = param.data;
            var id = (data.conversation || {}).id;
            if (id) {
                return router_default().replace({
                    query: {
                        id: id
                    },
                    pathname: shared/* PagePath.ConsultChatPage */._.ConsultChatPage
                });
            }
        },
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        }
    }), mutate = ref9.mutate, isCreateChatConversationLoading = ref9.isLoading;
    var ref10 = (0,detail_api/* useFetchConversationByProductQuery */.uK)(product.id, {
        retry: 0,
        enabled: false,
        onSuccess: function(data) {
            var id = (data.data || {}).id;
            if (id) {
                return router_default().replace({
                    query: {
                        id: id
                    },
                    pathname: shared/* PagePath.ConsultChatPage */._.ConsultChatPage
                });
            }
        },
        onError: function(error) {
            var productImages = Array.isArray(product.images) ? product.images : [];
            var typeImage = "";
            if (productImages.length) {
                var url = productImages[0].url;
                typeImage = url;
            }
            return mutate({
                title: product.product_name,
                type_id: product.id,
                type_image: typeImage,
                type_code: product.product_code,
                type: models/* ConversationType.Product */.i.Product
            });
        }
    }), fetchConversation = ref10.refetch, isFetchConversationLoading = ref10.isLoading;
    var isConsultLoading = isFetchConversationLoading || isCreateChatConversationLoading;
    var onConsultClick = function() {
        if (!isAuth) {
            var ref;
            localStorage.setItem("productUrl", ((ref = (router_default()).query) === null || ref === void 0 ? void 0 : ref.id) + "");
            return router_default().push(shared/* PagePath.LoginPage */._.LoginPage);
        } else {
            localStorage.removeItem("productUrl");
            return fetchConversation();
        }
    };
    var onRemindClick = function(checked) {
        mutateRemindProduct({
            product_id: product.id,
            remind: checked
        });
    };
    var handleModal = function() {
        return setShowModal(true);
    };
    var isDeposited = product.quantity <= 0 || product.status !== shared/* ProductStatus.Availability */.Pt.Availability;
    if (!masterData) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: product.product_name,
                description: product.description || product.product_name,
                image: product.images && ((ref = product.images[0]) === null || ref === void 0 ? void 0 : ref.url),
                type: "product",
                price: product.price,
                productCode: product.product_code,
                updated: (0,dayjs/* humanDate */.rN)(product.created_at),
                category: catCode || product.cat_code,
                productId: product.id,
                status: product.status,
                handle: "/products/" + handle,
                seo: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container tw-mx-auto md:tw-border-t tw-border-primary-main md:tw-pt-6 md:tw-pb-14 tw-pb-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-fixed tw-block md:tw-hidden tw-z-50 tw-top-6 tw-left-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-10 tw-h-10 tw-rounded-full tw-bg-gray-10 tw-flex tw-items-center tw-justify-center",
                            onClick: function() {
                                return router_default().back();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                className: "tw-w-6 tw-h-6 tw-text-primary-main",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex md:tw-pb-10 tw-flex-col md:tw-border-b tw-border-primary-main tw-border-opacity-50 tw-z-0 ".concat(isPartner && "!tw-border-opacity-0"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb, {
                                categoryName: product.cat_name,
                                categoryCode: product.cat_code,
                                isPartner: product.is_partner,
                                partnerId: (ref1 = product.partner) === null || ref1 === void 0 ? void 0 : ref1.id,
                                partnerName: (ref2 = product.partner) === null || ref2 === void 0 ? void 0 : ref2.fullname,
                                t: t,
                                title: product.product_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-grid tw-grid-cols-1 md:tw-mt-10 md:tw-grid-cols-2 md:tw-gap-y-4 tw-gap-x-0 sm:tw-gap-x-4 sm:tw-gap-y-0 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-flex-col",
                                        children: [
                                            isAuction && auction && auction.status === shared/* AuctionStatus.Started */.wo.Started && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tw-py-3 tw-px-4 tw-flex tw-mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown, {
                                                        startTime: auction.started_at,
                                                        endTime: auction.ended_time_at,
                                                        t: t
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-ml-4 tw-mt-5 tw-text-secondary-70 tw-text-base tw-lowercase",
                                                        children: "Thời gian đấu gi\xe1 c\xf2n lại"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tw-relative tw-flex-1",
                                                children: product.images ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "tw--mx-2 md:tw-mx-0 tw-relative",
                                                    children: [
                                                        product_discount && isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "tw-w-[43px] tw-h-[43px] tw-absolute tw-top-3 tw-right-3 tw-z-10",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                                    src: "/sale.png",
                                                                    className: "tw-w-full tw-h-full",
                                                                    alt: "sale"
                                                                })
                                                            })
                                                        }),
                                                        isDeposited && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "tw-absolute tw-z-10 tw-top-3 tw-left-0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PentagonIcon */.nM, {
                                                                text: t("detail.label.soldOut")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gallery, {
                                                            handleModal: handleModal,
                                                            linkVideo: product.link_video,
                                                            images: product.images,
                                                            isMobile: isMobile,
                                                            t: t
                                                        }),
                                                        " "
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-hidden md:tw-block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info, {
                                            t: t,
                                            data: product,
                                            isAuth: isAuth,
                                            auction: auction,
                                            onDepositClick: onDepositClick,
                                            onConsultClick: onConsultClick,
                                            isDeposited: isDeposited,
                                            isConsultLoading: isConsultLoading,
                                            onRemindClick: onRemindClick
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-block tw--mx-2 md:tw-hidden tw--mt-6 tw-z-1 custom-bg-info tw-bg-white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoMobile, {
                                            t: t,
                                            data: product,
                                            isAuth: isAuth,
                                            onRemindClick: onRemindClick
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !!liveStreamProducts && !isPartner && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-mt-10 tw-hidden md:tw-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "tw-flex tw-items-center tw-text-primary-main",
                                children: [
                                    icon_category_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: icon_category_url,
                                        alt: "star",
                                        className: "tw-h-5 tw-w-5 tw-mr-2"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DiamondFilledIcon */.hD, {}),
                                        className: "tw-w-5 tw-h-5 tw-opacity-50 tw-mr-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-text-xl",
                                        children: t("detail.label.view")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-mt-6 tw-grid tw-grid-cols-2 tw-gap-4",
                                children: liveStreamProducts.map(function(live) {
                                    var handle = "".concat((0,app/* createHandle */.UR)(live.live_stream.name), "-").concat(live.live_stream_id);
                                    return live.status && live.start_datetime && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        url: {
                                            pathname: shared/* PagePath.LiveVideoPage */._.LiveVideoPage,
                                            query: {
                                                id: handle,
                                                start: live.played
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-bg-muted-main tw-py-3 tw-px-4 tw-rounded-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LiveProduct */.SK, {
                                                data: live
                                            })
                                        })
                                    }, "live" + live.live_stream_id);
                                })
                            })
                        ]
                    }),
                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Loading */.gb, {}) : listProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-8 md:tw-mt-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProduct/* default */.Z, {
                            cateCode: product.cat_code,
                            products: listProduct,
                            title: t("detail.relatedProduct"),
                            t: t
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-grid tw-grid-cols-5 tw-gap-2 tw-items-center md:tw-hidden tw-fixed tw-left-0 tw-bottom-0 tw-z-20 tw-w-full tw-px-2 tw-bg-white tw-py-4",
                        children: product.quotation ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-col-span-5 tw-w-full tw-flex tw-justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                disabled: !product.quantity,
                                onClick: onConsultClick,
                                loading: isConsultLoading,
                                className: "tw-flex tw-items-center tw-justify-center !tw-w-44 !tw-rounded-5 sm:tw-w-1/2 tw-text-warning-90 tw-border-warning-90",
                                variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-lg tw-uppercase",
                                    children: t("detail.btn.contact")
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                    disabled: isDeposited,
                                    onClick: onConsultClick,
                                    loading: isConsultLoading,
                                    className: "tw-col-span-2 tw-flex tw-items-center tw-justify-center !tw-rounded-5 ".concat(isPartner && "tw-col-span-5"),
                                    variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-flex tw-gap-x-4 tw-justify-center tw-font-light tw-text-lg tw-text-black",
                                        children: t("detail.btn.consult")
                                    })
                                }),
                                !isPartner && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                    disabled: !isAuth || isDeposited || isPartner,
                                    onClick: onDepositClick,
                                    className: "w-flex tw-items-center tw-justify-center !tw-rounded-5 tw-col-span-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-gap-x-3 tw-justify-center tw-text-lg tw-capitalize",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WalletIcon */.o, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: !isDeposited ? t("detail.btn.deposit") : t("detail.btn.soldOut")
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            showModal && product.link_video && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Modal */.u_, {
                className: "!tw-max-w-4xl tw-bg-transparent tw-min-h-50-screen tw-h-auto tw-relative tw-flex tw-flex-col tw-gap-y-0 !tw-w-full !tw-p-2",
                clChildren: "!tw-gap-y-0",
                onClose: function() {
                    setShowModal(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalBody */.fe, {
                        className: "!tw-h-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            // url="https://www.facebook.com/anthukimcuong/videos/735500608077198"
                            url: product.link_video,
                            width: "100%",
                            height: product.link_video.includes("facebook") ? "60%" : "60vh",
                            config: {
                                facebook: {
                                    attributes: {
                                        height: isMobile ? "500px" : "550px"
                                    }
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-absolute tw--bottom-8 tw-left-1/2 md:tw-hidden tw--translate-x-1/2 tw-py-1 tw-px-3 tw-text-secondary-70 tw-bg-white tw-rounded-5",
                        onClick: function() {
                            return setShowModal(false);
                        },
                        children: "Close"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var layout = (ProductDetailLayout);

;// CONCATENATED MODULE: ./features/products/detail/index.ts

/* harmony default export */ var detail = (layout);


/***/ }),

/***/ 52685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ui_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34794);
/* harmony import */ var _components_loop_ProductLoop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90884);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7806);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85827);






var NewProduct = function(param) {
    var title = param.title, description = param.description, products = param.products, t = param.t, cateCode = param.cateCode, isHideSeeMore = param.isHideSeeMore;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                name: title,
                className: "_title-product-detail tw-text-lg tw-text-center md:tw-text-2xl",
                cs: "tw-w-40 md:tw-w-auto"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "tw-text-xl tw-text-secondary-70 tw-text-center tw-line-clamp-2 lg:tw-w-4/5 tw-mx-auto",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-2 tw-mt-10 lg:tw-gap-4",
                children: products.map(function(p, index) {
                    return [
                        0,
                        1,
                        2,
                        3
                    ].includes(index) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loop_ProductLoop__WEBPACK_IMPORTED_MODULE_3__/* .ProductLoop */ ._, {
                            catCode: p.cat_code,
                            p: p,
                            t: t
                        })
                    }, p.product_code);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-mt-10 tw-text-center tw-text-md ".concat(isHideSeeMore && "tw-hidden"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
                    className: "tw-italic tw-text-center !tw-underline",
                    url: {
                        pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .PagePath.CategoryPage */ ._.CategoryPage,
                        query: {
                            id: cateCode
                        }
                    },
                    children: t("detail.label.seemore")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(NewProduct));


/***/ }),

/***/ 30706:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);